import { formValueSelector } from 'redux-form';

import { INFERENTIAL_STATISTICS } from '../../names';
import { RAW_DATA } from 'scenes/InferentialStatistics/Constants';
import { getVisibleNumericalSelectedParametersNames } from 'store/dataset';
import { getInferentialStatistics } from 'store/form/inferentialStatistics/selectors';

export const PAIRED_T = 'PAIRED_T';

const selector = formValueSelector(INFERENTIAL_STATISTICS);

const makeFieldValueGetter = field =>
  state => selector(state, field);

export const getSampleMeanFirst =
  makeFieldValueGetter('pairedT.sampleMeanFirst');

export const getStandardDeviationFirst =
  makeFieldValueGetter('pairedT.standardDeviationFirst');

export const getSampleSizeFirst =
  makeFieldValueGetter('pairedT.sampleSizeFirst');

export const getSampleMeanSecond =
  makeFieldValueGetter('pairedT.sampleMeanSecond');

export const getStandardDeviationSecond =
  makeFieldValueGetter('pairedT.standardDeviationSecond');

export const getSampleSizeSecond =
  makeFieldValueGetter('pairedT.sampleSizeSecond');

export const getNumericalRowDataSetFirst =
  makeFieldValueGetter('pairedT.numericalRowDataSetFirst');

export const getNumericalRowDataSetSecond =
  makeFieldValueGetter('pairedT.numericalRowDataSetSecond');

export const getNumericalRowDataSet =
  makeFieldValueGetter('pairedT.numericalRowDataSet');

export const getDatasetContains =
  makeFieldValueGetter('pairedT.datasetContains');

export const getExpectedCounts =
  makeFieldValueGetter('chiSquare.expectedCounts');

export const isDatasetContainsRawData = state =>
  getDatasetContains(state) === RAW_DATA;

export const isPairedTInvalidForTwoGroups = state =>
  getVisibleNumericalSelectedParametersNames(state).length > 1 &&
  getInferentialStatistics(state) === PAIRED_T &&
  isDatasetContainsRawData(state) &&
  (!getNumericalRowDataSetFirst(state) || !getNumericalRowDataSetSecond(state));
